var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"network_warning",attrs:{"visible":_vm.isVisible}},[_c('p',[_vm._v(_vm._s(_vm.$t('network.not_mainnet')))])])}
var staticRenderFns = []

export { render, staticRenderFns }